/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';





import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-small-values-grouping',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoSmallValuesGroupingComponent extends NestedOption {
    @Input()
    get groupName(): string {
        return this._getOption('groupName');
    }
    set groupName(value: string) {
        this._setOption('groupName', value);
    }

    @Input()
    get mode(): string {
        return this._getOption('mode');
    }
    set mode(value: string) {
        this._setOption('mode', value);
    }

    @Input()
    get threshold(): number {
        return this._getOption('threshold');
    }
    set threshold(value: number) {
        this._setOption('threshold', value);
    }

    @Input()
    get topCount(): number {
        return this._getOption('topCount');
    }
    set topCount(value: number) {
        this._setOption('topCount', value);
    }


    protected get _optionPath() {
        return 'smallValuesGrouping';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoSmallValuesGroupingComponent
  ],
  exports: [
    DxoSmallValuesGroupingComponent
  ],
})
export class DxoSmallValuesGroupingModule { }
